import {createContext, useContext} from 'react';

const context = createContext(false);

export const BotModeProvider = context.Provider;
export const useIsBotModeEnabled = () => useContext(context);
